import { AbstractPlannerController } from '../../generated'
import CellFieldController from '../../lib/CellFieldController'
import { Collapsable } from '@mauriceguest/guest'

export default AbstractPlannerController

/** @constructor @extends {AbstractPlannerController} @suppress {checkTypes} */ function _AbstractPlannerController() {}
AbstractPlannerController.__implement(
 Collapsable,
 CellFieldController,
 _AbstractPlannerController.prototype = /** @type {!AbstractPlannerController} */ ({
  __$constructor() {
   // let today = new Date()
   // today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
   // setCalendarControllerSymbols(this, {
   //   _today: today,
   // })
  },
 }),
)
